import axios from '../axios'

const listTeachers = (data) =>
    axios.get('/api/teacher/teachers', {
        params: data,
    })

export default listTeachers